import Template from './root.component'

export default Template
